import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './mailing-address-message.module.scss'
import { ReactComponent as Warning } from '../../../assets/warning.svg'

const MailingAddressMessage: React.FC = () => {

    const { t } = useTranslation()

    return (
        <div className={styles.message}>
            <Warning />
            <h3>{t('mailingAddressMsgHeader')}</h3>
            <p>We highly recommend using an <strong>alternate address</strong> (such as a home address) that is consistently monitored to ensure successful delivery.</p>
        </div>
    );

};

export default MailingAddressMessage;
